export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const NOTIFICATION_DISPLAYED = 'NOTIFICATION_DISPLAYED';
export const NOTIFICATION_HIDDEN = 'NOTIFICATION_HIDDEN';
export const NOTIFICATION_CLEAR = 'NOTIFICATION_CLEAR';
export const NOTIFICATION_CLEAR_RESET = 'NOTIFICATION_CLEAR_RESET';
